import styled from 'styled-components'

export const Title = styled.h5`
  margin-bottom: 8px;
`

export const Note = styled.p`
  font: var(--theme-typography-bodyM-regular);
  margin-bottom: 20px;
`
